import { render, staticRenderFns } from "./set_card.vue?vue&type=template&id=1d0f2e74&scoped=true"
import script from "./set_card.vue?vue&type=script&lang=js"
export * from "./set_card.vue?vue&type=script&lang=js"
import style0 from "./set_card.vue?vue&type=style&index=0&id=1d0f2e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0f2e74",
  null
  
)

export default component.exports